package dev.lingvo.ops.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.navigation.Link
import dev.lingvo.ops.api.OpsApi
import dev.lingvo.ops.components.OpsCapNotice
import dev.lingvo.ops.components.OpsPageHeader
import dev.lingvo.ops.components.OpsPanel
import dev.lingvo.ops.components.OpsResourceStates
import dev.lingvo.ops.components.OpsShell
import dev.lingvo.ops.state.jobRiskOrder
import dev.lingvo.ops.state.refundedLabel
import dev.lingvo.ops.state.rememberOpsResource
import dev.lingvo.site.ds.LTable
import dev.lingvo.site.ds.LTableBody
import dev.lingvo.site.ds.LTableCell
import dev.lingvo.site.ds.LTableHead
import dev.lingvo.site.ds.LTableHeaderCell
import dev.lingvo.site.ds.LTableRow
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.formatCount
import dev.lingvo.site.ds.formatUtc
import org.jetbrains.compose.web.dom.Text

@Page("/jobs")
@Composable
fun JobsPage() {
    OpsShell("Jobs") {
        val resource = rememberOpsResource(Unit) { OpsApi.jobHealth() }
        Column(Modifier.fillMaxWidth().gap(Space.XL)) {
        OpsPageHeader("Jobs", "Review failed, abandoned and recent translation jobs. This is a bounded health window.", resource.state.isRefreshing, resource::refresh)
        OpsResourceStates(resource.state, "No jobs", "No translation jobs are recorded.", retry = resource::refresh) { health ->
            OpsPanel("Risk-ordered health window", "Abandoned is derived server-side; this list is bounded rather than offset-paged.") {
                OpsCapNotice(health.recent.size >= health.cappedAt, health.cappedAt, "jobs")
                LTable(caption = "Translation job health") { LTableHead { LTableRow { listOf("Workspace", "Project", "Provider", "State", "Attempted", "Done", "Failed", "Rejected", "Reserved", "Refunded", "Created").forEach { LTableHeaderCell { Text(it) } } } }; LTableBody { jobRiskOrder(health.recent).forEach { row -> LTableRow {
                    LTableCell { Link("/jobs/${row.jobId}") { Text(row.orgName ?: "Unknown workspace") } }; LTableCell { Text(row.projectSlug ?: "—") }; LTableCell { Text(row.provider.displayName) }; LTableCell { Text(row.state.name) }; LTableCell { Text(formatCount(row.total)) }; LTableCell { Text(formatCount(row.done)) }; LTableCell { Text(formatCount(row.failed)) }; LTableCell { Text(formatCount(row.rejected)) }; LTableCell { Text(formatCount(row.reservedCredits)) }; LTableCell { Text(refundedLabel(row.state, row.refundedCredits)) }; LTableCell { Text(formatUtc(row.createdAt)) }
                } } } }
            }
        }
    } }
}
